<div class="rule-form-container modern-container fade-in-up">
    <form [formGroup]="ruleForm" (ngSubmit)="onSubmit()">
        <!-- Rules Section (for most rule types) -->
        <div class="modern-card mb-4" *ngIf="ruleType !== 'joint' && ruleType !== 'mating'">
            <div class="modern-card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                    <i class="bi bi-list-ul me-2"></i> Rules
                </h5>
                <button type="button" class="btn btn-modern btn-sm" (click)="addRule()">
                    <i class="bi bi-plus-circle me-1"></i> Add Rule
                </button>
            </div>
            <div class="modern-card-body">
            <div formArrayName="rules">
                <div *ngFor="let ruleGroup of rulesArray.controls; let i = index" [formGroupName]="i"
                    class="rule-item mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label">Rule ID *</label>
                            <input type="text" class="form-control" formControlName="ruleId"
                                placeholder="Enter rule ID">
                            <div *ngIf="ruleGroup.get('ruleId')?.invalid && ruleGroup.get('ruleId')?.touched"
                                class="text-danger small">
                                Rule ID is required
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Description *</label>
                            <input type="text" class="form-control" formControlName="description"
                                placeholder="Enter rule description">
                            <div *ngIf="ruleGroup.get('description')?.invalid && ruleGroup.get('description')?.touched"
                                class="text-danger small">
                                Description is required
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Custom Code</label>
                            <input type="text" class="form-control" formControlName="customCode" placeholder="Code">
                        </div>
                        <div class="col-md-1 d-flex align-items-end">
                            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeRule(i)"
                                title="Remove Rule">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <!-- Drainage Ventilation Items -->
        <div class="modern-card mb-4" *ngIf="ruleType === 'drainage-ventilation'">
            <div class="modern-card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                    <i class="bi bi-droplet me-2"></i> Drainage Ventilation Items
                </h5>
                <button type="button" class="btn btn-modern btn-sm"
                    (click)="addDrainageVentilationItem()">
                    <i class="bi bi-plus-circle me-1"></i> Add Item
                </button>
            </div>
            <div class="modern-card-body">
            <div formArrayName="items">
                <div *ngFor="let itemGroup of itemsArray.controls; let i = index" [formGroupName]="i"
                    class="item-container mb-4 p-3 border rounded">
                    <div class="row mb-3">
                        <div class="col-md-3">
                            <label class="form-label">DV ID *</label>
                            <input type="text" class="form-control" formControlName="dvId" placeholder="Enter DV ID">
                            <div *ngIf="itemGroup.get('dvId')?.invalid && itemGroup.get('dvId')?.touched"
                                class="text-danger small">
                                DV ID is required
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Description *</label>
                            <input type="text" class="form-control" formControlName="description"
                                placeholder="Enter item description">
                            <div *ngIf="itemGroup.get('description')?.invalid && itemGroup.get('description')?.touched"
                                class="text-danger small">
                                Description is required
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Image URL</label>
                            <input type="url" class="form-control" formControlName="imageUrl" placeholder="Image URL">
                        </div>
                        <div class="col-md-1 d-flex align-items-end">
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                (click)="removeDrainageVentilationItem(i)" title="Remove Item">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Drainage Ventilation Sections -->
                    <h6 class="mb-2">Sections</h6>
                    <div formArrayName="drainageVentilationSections">
                        <div *ngFor="let sectionGroup of getDrainageVentilationSections(itemGroup); let j = index"
                            [formGroupName]="j" class="section-item mb-2 p-2 border rounded bg-light">
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">Description *</label>
                                    <input type="text" class="form-control" formControlName="description"
                                        placeholder="Section description">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Type *</label>
                                    <input type="text" class="form-control" formControlName="type"
                                        placeholder="Section type">
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">Articles</label>
                                    <input type="text" class="form-control" formControlName="articles"
                                        placeholder="Articles (JSON)">
                                </div>
                                <div class="col-md-1 d-flex align-items-end">
                                    <button type="button" class="btn btn-sm btn-outline-danger"
                                        (click)="removeDrainageVentilationSection(i, j)" title="Remove Section">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="addDrainageVentilationSection(itemGroup)">
                            <i class="bi bi-plus"></i> Add Section
                        </button>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <!-- Glazing Items -->
        <div class="modern-card mb-4" *ngIf="ruleType === 'glazing'">
            <div class="modern-card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                    <i class="bi bi-window me-2"></i> Glazing Items
                </h5>
                <button type="button" class="btn btn-modern btn-sm" (click)="addGlazingItem()">
                    <i class="bi bi-plus-circle me-1"></i> Add Item
                </button>
            </div>
            <div class="modern-card-body">
            <div formArrayName="items">
                <div *ngFor="let itemGroup of itemsArray.controls; let i = index" [formGroupName]="i"
                    class="item-container mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label">Rule ID *</label>
                            <input type="text" class="form-control" formControlName="ruleId"
                                placeholder="Enter rule ID">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Template *</label>
                            <input type="text" class="form-control" formControlName="template"
                                placeholder="Enter template">
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Description *</label>
                            <input type="text" class="form-control" formControlName="description"
                                placeholder="Enter description">
                        </div>
                        <div class="col-md-1">
                            <label class="form-label">Decision Table</label>
                            <textarea class="form-control" formControlName="decisionTable"
                                placeholder="Decision table (JSON)" rows="2"></textarea>
                        </div>
                        <div class="col-md-1 d-flex align-items-end">
                            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeGlazingItem(i)"
                                title="Remove Item">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <!-- Integrated Items -->
        <div class="modern-card mb-4" *ngIf="ruleType === 'integrated'">
            <div class="modern-card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                    <i class="bi bi-puzzle me-2"></i> Integrated Items
                </h5>
                <button type="button" class="btn btn-modern btn-sm" (click)="addIntegratedItem()">
                    <i class="bi bi-plus-circle me-1"></i> Add Item
                </button>
            </div>
            <div class="modern-card-body">
            <div formArrayName="Items">
                <div *ngFor="let itemGroup of itemsArray.controls; let i = index" [formGroupName]="i"
                    class="item-container mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label">Name *</label>
                            <input type="text" class="form-control" formControlName="name" placeholder="Enter name">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Type *</label>
                            <input type="text" class="form-control" formControlName="type" placeholder="Type">
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Description *</label>
                            <input type="text" class="form-control" formControlName="description"
                                placeholder="Enter description">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Image URL</label>
                            <input type="url" class="form-control" formControlName="imageUrl" placeholder="Image URL">
                        </div>
                        <div class="col-md-1 d-flex align-items-end">
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                (click)="removeIntegratedItem(i)" title="Remove Item">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <!-- Joints -->
        <div class="modern-card mb-4" *ngIf="ruleType === 'joint'">
            <div class="modern-card-header">
                <h5 class="mb-0">
                    <i class="bi bi-link-45deg me-2"></i> Joint Rule Configuration
                </h5>
            </div>
            <div class="modern-card-body">
                <div class="row g-3 mb-4">
                    <div class="col-md-12">
                        <label class="form-label fw-semibold"><i class="bi bi-gear me-1"></i> System *</label>
                        <select class="form-select modern-input" formControlName="systemId">
                            <option value="">Select System</option>
                            <option *ngFor="let s of systems" [value]="s.id">
                                {{ s.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row g-3 mb-4">
                    <div class="col-md-4">
                        <label class="form-label fw-semibold"><i class="bi bi-hash me-1"></i> Rule ID *</label>
                        <input type="text" class="form-control modern-input" formControlName="ruleId"
                            placeholder="e.g., JR-001">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label fw-semibold"><i class="bi bi-tag me-1"></i> Name *</label>
                        <input type="text" class="form-control modern-input" formControlName="name"
                            placeholder="Enter rule name">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label fw-semibold"><i class="bi bi-info-circle me-1"></i> Description *</label>
                        <input type="text" class="form-control modern-input" formControlName="description"
                            placeholder="Enter rule description">
                    </div>
                </div>

                <!-- Joint Sections -->
                <div class="section-header mt-4 mb-3">
                    <h6 class="mb-0"><i class="bi bi-diagram-3 me-2"></i> Joint Sections</h6>
                </div>
                <div formArrayName="jointSections" class="sections-container">
                    <div *ngFor="let sectionGroup of getJointSections(); let j = index"
                        [formGroupName]="j" class="modern-sub-card mb-3 fade-in-animation">
                        <div class="sub-card-header">
                            <span class="badge bg-primary">Section {{ j + 1 }}</span>
                        </div>
                        <div class="row g-3">
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-card-text me-1"></i> Description *</label>
                                <input type="text" class="form-control modern-input" formControlName="description"
                                    placeholder="Section description">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-box me-1"></i> Material *</label>
                                <input type="text" class="form-control modern-input" formControlName="material"
                                    placeholder="e.g., Aluminum">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-tag me-1"></i> Type *</label>
                                <input type="text" class="form-control modern-input" formControlName="type" placeholder="Type">
                            </div>
                        </div>
                        <div class="row g-3 mt-2">
                            <div class="col-md-5">
                                <label class="form-label"><i class="bi bi-list-ul me-1"></i> Articles</label>
                                <input type="text" class="form-control modern-input" formControlName="articles"
                                    placeholder="[{...}]">
                            </div>
                            <div class="col-md-5">
                                <label class="form-label"><i class="bi bi-image me-1"></i> Image URL</label>
                                <input type="url" class="form-control modern-input" formControlName="imageUrl" placeholder="https://...">
                            </div>
                            <div class="col-md-2 d-flex align-items-end">
                                <button type="button" class="btn btn-outline-danger btn-sm w-100 hover-lift"
                                    (click)="removeJointSection(0, j)" title="Remove Section">
                                    <i class="bi bi-trash me-1"></i> Remove
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="text-center mt-3">
                        <button type="button" class="btn btn-modern btn-sm"
                            (click)="addJointSection(null)">
                            <i class="bi bi-plus-circle me-1"></i> Add Joint Section
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Limitation Items -->
        <div class="modern-card mb-4" *ngIf="ruleType === 'limitation'">
            <div class="modern-card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                    <i class="bi bi-exclamation-triangle me-2"></i> Limitation Items
                </h5>
                <button type="button" class="btn btn-modern btn-sm" (click)="addLimitationItem()">
                    <i class="bi bi-plus-circle me-1"></i> Add Item
                </button>
            </div>
            <div class="modern-card-body">
            <div formArrayName="Items">
                <div *ngFor="let itemGroup of itemsArray.controls; let i = index" [formGroupName]="i"
                    class="item-container mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label">Name *</label>
                            <input type="text" class="form-control" formControlName="name" placeholder="Enter name">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Type *</label>
                            <input type="text" class="form-control" formControlName="type" placeholder="Type">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Image URL</label>
                            <input type="url" class="form-control" formControlName="imageUrl" placeholder="Image URL">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Dimensions</label>
                            <textarea class="form-control" formControlName="dimensions" placeholder="Dimensions (JSON)"
                                rows="2"></textarea>
                        </div>
                        <div class="col-md-1 d-flex align-items-end">
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                (click)="removeLimitationItem(i)" title="Remove Item">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <!-- Sections (for Mating rules) -->
        <!-- <div class="mb-4" *ngIf="ruleType === 'mating'">
            <h5 class="mb-3">
                <i class="bi bi-diagram-3"></i> Sections
                <button type="button" class="btn btn-sm btn-outline-primary ms-2" (click)="addSection()">
                    <i class="bi bi-plus"></i> Add Section
                </button>
            </h5>
            <div formArrayName="Sections">
                <div *ngFor="let sectionGroup of sectionsArray.controls; let i = index" [formGroupName]="i"
                    class="section-container mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label">Section ID *</label>
                            <input type="text" class="form-control" formControlName="sectionId"
                                placeholder="Enter section ID">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Description *</label>
                            <input type="text" class="form-control" formControlName="description"
                                placeholder="Enter section description">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Image URL</label>
                            <input type="url" class="form-control" formControlName="imageUrl" placeholder="Image URL">
                        </div>
                        <div class="col-md-1 d-flex align-items-end">
                            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeSection(i)"
                                title="Remove Section">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- Sections (for Mating rules) -->
        <div class="modern-card mb-4" *ngIf="ruleType === 'mating'">
            <div class="modern-card-header">
                <h5 class="mb-0">
                    <i class="bi bi-diagram-3 me-2"></i> Mating Rule Configuration
                </h5>
            </div>
            <div class="modern-card-body">
                <div class="row g-3 mb-4">
                    <div class="col-md-12">
                        <label class="form-label fw-semibold"><i class="bi bi-gear me-1"></i> System *</label>
                        <select class="form-select modern-input" formControlName="systemId">
                            <option value="">Select System</option>
                            <option *ngFor="let s of systems" [value]="s.id">
                                {{ s.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row g-3 mb-4">
                    <div class="col-md-4">
                        <label class="form-label fw-semibold"><i class="bi bi-hash me-1"></i> Rule ID *</label>
                        <input type="text" class="form-control modern-input" formControlName="ruleId" placeholder="e.g., MR-001">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label fw-semibold"><i class="bi bi-tag me-1"></i> Name *</label>
                        <input type="text" class="form-control modern-input" formControlName="name" placeholder="Enter rule name">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label fw-semibold"><i class="bi bi-info-circle me-1"></i> Description *</label>
                        <input type="text" class="form-control modern-input" formControlName="description" placeholder="Enter rule description">
                    </div>
                </div>

                <!-- Cross Sections -->
                <div class="section-header mt-4 mb-3">
                    <h6 class="mb-0"><i class="bi bi-grid-3x3 me-2"></i> Cross Sections & Transformation Data</h6>
                </div>
                <div formArrayName="crossSections" class="sections-container">
                    <div *ngFor="let crossSectionGroup of getCrossSections(); let j = index"
                        [formGroupName]="j" class="modern-sub-card mb-3 fade-in-animation">
                        <div class="sub-card-header d-flex justify-content-between align-items-center">
                            <span class="badge bg-primary">Cross Section {{ j + 1 }}</span>
                            <small class="text-muted"><i class="bi bi-info-circle me-1"></i> Transformation & Article Data</small>
                        </div>
                        <div class="row g-3">
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-card-text me-1"></i> Description *</label>
                                <input type="text" class="form-control modern-input" formControlName="description"
                                    placeholder="Section description">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-box me-1"></i> Material *</label>
                                <input type="text" class="form-control modern-input" formControlName="material"
                                    placeholder="e.g., Steel, Aluminum">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"><i class="bi bi-tag me-1"></i> Type *</label>
                                <input type="text" class="form-control modern-input" formControlName="type" placeholder="Type">
                            </div>
                        </div>

                        <div class="transformation-section mt-3">
                            <h6 class="text-muted mb-2"><i class="bi bi-arrows-move me-2"></i> Position</h6>
                            <div class="row g-3">
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-arrow-left-right me-1"></i> X Axis *</label>
                                    <input type="number" class="form-control modern-input" formControlName="positionX" placeholder="0.0">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-arrow-up-down me-1"></i> Y Axis *</label>
                                    <input type="number" class="form-control modern-input" formControlName="positionY" placeholder="0.0">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-arrow-bar-up me-1"></i> Z Axis *</label>
                                    <input type="number" class="form-control modern-input" formControlName="positionZ" placeholder="0.0">
                                </div>
                            </div>
                        </div>
                        <div class="transformation-section mt-3">
                            <h6 class="text-muted mb-2"><i class="bi bi-aspect-ratio me-2"></i> Scale & Rotation</h6>
                            <div class="row g-3">
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-arrows-expand me-1"></i> Scale X *</label>
                                    <input type="number" class="form-control modern-input" formControlName="scaleX" placeholder="1.0">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-arrows-expand me-1"></i> Scale Y *</label>
                                    <input type="number" class="form-control modern-input" formControlName="scaleY" placeholder="1.0">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-arrow-clockwise me-1"></i> Rotation (degrees) *</label>
                                    <input type="number" class="form-control modern-input" formControlName="rotation" placeholder="0">
                                </div>
                            </div>
                        </div>
                        <div class="article-section mt-3">
                            <h6 class="text-muted mb-2"><i class="bi bi-journal-text me-2"></i> Article Data</h6>
                            <div class="row g-3">
                                <div class="col-md-5">
                                    <label class="form-label"><i class="bi bi-list-ul me-1"></i> Articles (JSON)</label>
                                    <input type="text" class="form-control modern-input" formControlName="articles"
                                        placeholder='[{"id":"ART-001","qty":2}]'>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label"><i class="bi bi-image me-1"></i> Image URL</label>
                                    <input type="url" class="form-control modern-input" formControlName="imageUrl" placeholder="https://...">
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label"><i class="bi bi-symmetry-vertical me-1"></i> Mirrored</label>
                                    <div class="form-check form-switch mt-2">
                                        <input class="form-check-input" type="checkbox" formControlName="isMirrored" id="mirror-{{ j }}">
                                        <label class="form-check-label" for="mirror-{{ j }}">
                                            {{ crossSectionGroup.get('isMirrored')?.value ? 'Yes' : 'No' }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end mt-3">
                            <button type="button" class="btn btn-outline-danger btn-sm hover-lift"
                                (click)="removeCrossSection(0, j)" title="Remove Cross Section">
                                <i class="bi bi-trash me-1"></i> Remove
                            </button>
                        </div>
                    </div>
                    <div class="text-center mt-3">
                        <button type="button" class="btn btn-modern btn-sm"
                            (click)="addCrossSection(null)">
                            <i class="bi bi-plus-circle me-1"></i> Add Cross Section
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions d-flex justify-content-end gap-3 mt-4">
            <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="loading">
                <i class="bi bi-x-circle me-2"></i> Cancel
            </button>
            <button type="submit" class="btn btn-sm btn-primary" [disabled]="loading || ruleForm.invalid">
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
                <i *ngIf="!loading" class="bi bi-{{ isEditMode ? 'check-circle' : 'save' }} me-2"></i>
                {{ isEditMode ? 'Update Rule' : 'Save Rule' }}
            </button>
        </div>
    </form>
</div>
<!-- <app-toasts aria-live="polite" aria-atomic="true"></app-toasts> -->